import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';
import { ExportsListFacade } from './exports-list.facade';

@Injectable({
  providedIn: 'root',
})
export class ExportsListGuard {
  constructor(private exportsListFacade: ExportsListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.exportsListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.exportsListFacade);
  }
}
